import { z } from 'zod';
import avatars from '../config/avatars';

export let avatarIdSchema = z.enum(
  Object.keys(avatars) as [keyof typeof avatars, ...(keyof typeof avatars)[]]
);

export let userProfileSchema = z.object({
  id: z.string(),
  avatarBackgroundHex: z.string().nullable().optional(),
  avatarId: avatarIdSchema.optional(),
  handle: z.string().optional(),
  letterboxdId: z.string().nullable().optional(),
});

export type UserProfileType = z.infer<typeof userProfileSchema>;

export let allUserProfilesSchema = z.object({
  users: z.record(z.string(), userProfileSchema),
});

export type AllUserProfilesType = z.infer<typeof allUserProfilesSchema>;
